import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import "./index.css";
import { LanguageProvider } from "./Components/LangTranslation/LanguageContext";
import { SessionProvider } from "./authentications/SessionContext";
import store from "./Redux/store/store";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import { SnackbarProvider } from "notistack";
import { NotificationProvider } from "./contexts/NotificationProvider";
import { PollingProvider } from "./contexts/PollingContext";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SnackbarProvider
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      maxSnack={3}
      autoHideDuration={2500}
    >
      <HelmetProvider>
        <SessionProvider>
          <NotificationProvider>
            <PollingProvider>
              <Provider store={store}>
                <LanguageProvider>
                  <App />
                </LanguageProvider>
              </Provider>
            </PollingProvider>
          </NotificationProvider>
        </SessionProvider>
      </HelmetProvider>
    </SnackbarProvider>
  </React.StrictMode>
);
reportWebVitals();
